import axios from 'axios'
// import { Message, MessageBox } from 'element-ui'
// import store from '@/store'
import cookies from 'js-cookie'

// import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.TMH_API, // api 的 base_url
  timeout: 60000*60 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // if (store.getters.token) {
    //   config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    var token=  cookies.get('token') ;
    config.headers['x-access-token'] = token==undefined?'' :  token; // 让每个请求携带自定义token 请根据实际情况自行修改
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/config/tmhRequest.js